import { axiosWdw, domainEndpoint } from './axios';

export default {
  getAskus(id: number) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + `/askus/` + id,
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getQuestions(id: number, page: number, sort: string, params: any) {
    if (!params.visible && params.visible != 0) {
      params.visible = 1;
    }
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url:
          domainEndpoint() +
          `/askus_question?` +
          `rows=10` +
          `&askusid=${id}` +
          `&page=${page}` +
          '&fieldset=all' +
          `&sort=${sort}`,
        params: params,
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getQuestion(id: number) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + `/askus_question/${id}` + `?fieldset=all`,
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getAnswer(id: number) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + `/askus_question/` + id + '/answer',
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getSuggestions(askusid: number, text: string) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/askus/' + askusid + '/question_suggestion?' + `text=${text}`,
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  createQuestion(id: number, params: any) {
    return new Promise((resolve, reject) => {
      const formdata = new FormData();
      formdata.append('data', JSON.stringify(params));
      axiosWdw({
        method: 'post',
        url: domainEndpoint() + `/askus_question`,
        headers: { 'Content-Type': 'form-data' },
        data: params,
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
};
